import axios from '@axios'

/**
 * 관리자 로그 API > 개인정보 열람 기록
 * @param {*} custId 조회 대상 고객 이름 또는, 고객 계정 또는, 고객 번호
 * @param {*} accessType // 조회 타입 (C - 생성, R - 읽기, U - 수정, D – 삭제, P – 개인정보다운로드)
 * @param {*} guardType // 조회한 정보 모두 나열 (ex: 이름|생년월일|이메일|휴대전화번호),
 * @param {*} etc // 비고
 */
export const custInfoInsert = async (custId, accessType, guardType, etc) => {
  try {
    const currentUrl = window.location.href

    const defaultEtc = process.env.NODE_ENV === 'production' ? '고객 상세정보 조회' : '테스트'

    // 조회자 이름은 백엔드가 인증 Claims에서 자체 추출 (위변조 방어 + 응답 평문 제외 대응)
    await axios.post('/fa/common/logging/cust-info/insert', {
      custId,
      fullURLPath: currentUrl, // 조회 페이지 URL
      accessType,
      guardType,
      etc: etc || defaultEtc,
    })

    return true
  } catch (err) {
    return false
  }
}

export const test = () => {}
